import { ITracking } from '.';
import { GA_TOKEN } from '../api/constants';
import { MyProfileResponse } from '../api/fetchMyProfile';
import { cachedRouteParams } from '../App';

export const Ga: ITracking = {
    initTracking() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        gtag?.('config', GA_TOKEN);
    },

    setTrackingIdentify(myprofile: MyProfileResponse) {
        const profile = myprofile.doctor;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        gtag?.('config', 'TAG_ID', {
            user_id: profile?._id || myprofile.user.oid,
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        gtag?.('set', 'user_properties', {
            user_id: profile?._id || myprofile.user.oid,
            doc_id: profile?._id,
            name: profile?.profile.personal.name.f || myprofile.user.fn,
            role: myprofile.loginmeta?.role,
            category: profile?.profile.professional.category?.join(', '),
        });
    },

    resetTracking() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        gtag?.('config', 'TAG_ID', {
            user_id: '',
        });
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        gtag?.('set', 'user_properties', {});
    },

    track(name, params) {
        const p = params
            ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              { ...cachedRouteParams, ...params, APP_VERSION: APP_VERSION }
            : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              { ...cachedRouteParams, APP_VERSION: APP_VERSION };
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        gtag?.('event', name, p);
    },

    timeTrackStart(name: string) {
        return;
    },
};
